import React from 'react'
import { intl } from 'lang/intl'

import { TtIcon } from '@23/ui-react'

import { LoaderComponent } from '../../sharedLegacy/components'
import { useHandoutsQuery } from '../blocs/useHandouts'
import { type Handout, type HandoutIconName } from '../model/Handout'

import './HandoutsList.scss'

const fileTypeIconMap = {
  audio: 'mp3',
  video: 'mp4',
  presentation: 'presentation',
  document: 'file-document',
  generic: 'file-attachment',
  image: 'image',
} as const satisfies Record<HandoutIconName, string>

const HandoutFile = ({ handout }: { handout: Handout }) => (
  <div className="handout-file">
    <TtIcon className="file-icon" name={fileTypeIconMap[handout.iconName]} />
    <div className="filename">{handout.name}</div>
    <div className="buttons">
      <a
        href={handout.url}
        target="_blank"
        rel="noopener noreferrer"
        download
        aria-label={intl.formatMessage(
          { defaultMessage: 'Download {handoutName}' },
          { handoutName: handout.name }
        )}
      >
        <TtIcon className="download-icon" name="download" />
      </a>
    </div>
  </div>
)

// The LoadingWrapperComponent doesn't work because it has min-height
// and when there are no items to display it takes the same min-height
// which on Mobile looks like a big empty whole

const HandoutsList = ({ liveToken }: { liveToken?: string }) => {
  const { data: handouts, isLoading } = useHandoutsQuery(liveToken)

  return (
    <div className="handouts-list">
      {isLoading ? (
        <div className="loading-wrapper">
          <LoaderComponent size="small" />
        </div>
      ) : (
        !!handouts?.length && (
          <div className="handouts-view-list">
            {handouts.map((handout) => (
              <HandoutFile handout={handout} key={handout.name} />
            ))}
          </div>
        )
      )}
    </div>
  )
}

export { HandoutsList }
